export const Routes = {
  Home: '/',
  CollectionDetail: '/collections/:slug',
  CityDetail: '/cities/:slug',
  PageDetail: '/pages/:slug',
  PageDetailEmbed: '/pages/:slug/embed',

  // Events
  EventDetail: '/events/:slug',
  EventCart: '/events/:slug/cart',
  EventInquiry: '/events/:slug/inquiries/:id',
  EventCheckout: '/events/:slug/checkout',
  EventCheckoutConfirmation: '/events/:slug/checkout/confirmation',

  // Ticket Offers
  EventTicketOffer: '/offers/events/:slug/code/:code',

  // Transers
  AcceptTransfer: '/transfers/accept',

  // Account
  Account: '/account',
  AccountDetails: '/account/details',
  AccountTickets: '/account/tickets',
  AccountTicketsDetail: '/account/tickets/:slug',
  AccountOnboarding: '/account/onboarding',
  // Account Loyalty
  AccountOnboardingLoyalty: '/account/onboarding/loyalty',
  AccountLoyaltyTiers: '/account/loyalty/tiers',
  AccountLoyaltyCurrentTier: '/account/loyalty/current-tier',

  // Loyalty Information
  LoyaltyInformation: '/loyalty',

  // Saudi Rewards
  SaudiRewardsRetroRedeem: '/saudi-rewards/retro-redeem',

  // Misc
  Notfound: '/404',
  ApiExitPreview: '/api/exit-preview',
  PrivacyPolicy: '/privacy-policy',
  TermsOfService: '/terms-and-conditions',
  UnsupportedDevice: '/support/unsupported-device',

  // Auth
  Login: '/login',
  SsoCallback: '/auth/sso-callback',
  EmailLinkVerification: '/auth/email-link-verification',
  EmailLinkLoading: '/auth/email-link-loading',
  AuthenticateWebview: '/auth/webview',

  // The reason this doesn't start with a "/" is because it's used in the app redirect
  AppTicketDetails: 'tickets/:slug/:eventId/detail/:ticketId',
  AppTickets: 'account/tickets',

  // Store
  Store: '/store',
} as const;
